<style scoped>
.navbrand-supersafra{
  text-decoration: none !important;
  font-family: 'Libre Baskerville', serif; 
  color: #3e4095; 
  text-shadow: white 1px 1px 1px; 
  letter-spacing: -4px;
  vertical-align: text-middle; 
  font-size: 20px;
}

.navbrand-supersafra:hover{
  text-decoration: none !important;
  font-family: 'Libre Baskerville', serif; 
  color: #3e4095; 
  text-shadow: white 1px 1px 1px; 
  letter-spacing: -4px;
  vertical-align: text-middle; 
  font-size: 20px;
}

.navbrand-supersafra:focus{
  text-decoration: none !important;
  font-family: 'Libre Baskerville', serif; 
  color: #3e4095; 
  text-shadow: white 1px 1px 1px; 
  letter-spacing: -4px;
  vertical-align: text-middle; 
  font-size: 20px;
}

.icone-navbrand-supersafra{
  width: 27.5px;
}
</style>
<template>
    <div class="container">
        <!--/ Nav Star /-->
        <nav class="navbar navbar-b navbar-trans bg-white navbar-expand-md fixed-top navbar-reduce" id="mainNav">
            <div class="container">
            <a class="js-scroll" href="/">
                <div style="float: left" class="mr-1">
                    <img :src="url+'/images/logo.webp'" alt="Logomarca do Site" class="icone-navbrand-supersafra">
                </div>
                <div class="ml-1 text-center" style="float: right">
                    <div class="text-uppercase navbrand-supersafra">Grupo&nbsp; Super&nbsp;&nbsp; Safra<br></div>
                    <div style="margin-top: -10px;"><strong style="font-family:'Sarah-script'; color: #994234; margin-bottom: -15px;">Tecnologia a serviço da terra!</strong></div>
                </div>
            </a>
            <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarDefault"
                aria-controls="navbarDefault" aria-expanded="false" aria-label="Toggle navigation">
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div class="navbar-collapse collapse justify-content-end" id="navbarDefault">
                <ul class="navbar-nav">
                <li class="nav-item">
                    <a href="/" class="nav-link btn btn-link btn-sm"><i class="fas fa-home"></i> Início</a>
                </li>
                </ul>
            </div>
            </div>
        </nav>
        <!--/ Nav End /-->
    </div>
</template>

<script>
    export default {
        data(){
            return{
                location: window.location.host,
                url: 'https://'+window.location.host
            }
        }
    }
</script>
